import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ConsultaCnpjService } from 'src/app/core/services/consulta-cnpj.service';
import { FontesConsultaCnpjModel } from 'src/app/dominio/fontes-consulta-cnpj-model';
import { VendaEnderecoModalComponent } from 'src/app/modals/venda-endereco-modal/venda-endereco-modal.component';
import { TipoEnderecoEntrega } from 'src/app/models/enum';
import { Ibge } from 'src/app/models/ibge';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { VendaEntrega } from 'src/app/models/venda-entrega';
import { ViaCep } from 'src/app/models/viacep';
import { CarregandoService } from 'src/app/services/carregando.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import swal from 'sweetalert2';

// jquery
declare const $: any;

@Component({
  selector: 'app-venda-entrega',
  templateUrl: './venda-entrega.component.html',
  styleUrls: ['./venda-entrega.component.scss']
})
export class VendaEntregaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() enderecoEntrega = new VendaEntrega();
  @Input() mostrarDadosPessoa = false;
  @Input() validarDadosPessoa = false;
  @Input() msgEnderecoAdicional: string;
  @Input() somenteLeitura = false;
  @Output() retornar = new EventEmitter();

  ePedido = false;

  tiposDePessoa = [
    { id: 1, nome: 'FÍSICA' },
    { id: 0, nome: 'JURÍDICA' }
  ];
  estados = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO'
  ];

  cidades: any[] = [];
  inscricaoEstadualObg = false;
  bloqueiaAlterecaoEndereco = false;
  buscouCNPJ = false;

  fontesConsultaCnpj: FontesConsultaCnpjModel[] = [];

  premissasSistema: PremissasSistema = new PremissasSistema();

  formChangesSubscription$: any;
  @ViewChild('vendaEnderecoForm', { static: true }) vendaEnderecoForm: NgForm;

  public MASKS = MASKS;
  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private viaCepService: ViaCepService,
    private premissasService: PremissasService,
    private consultaCnpjService: ConsultaCnpjService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    // this.enderecoEntrega = data.enderecoEntrega;
    // this.mostrarDadosPessoa = data.mostrarDadosPessoa;
    // this.ePedido = Boolean(data.mostrarDadosPessoa);
    // this.validarDadosPessoa = data.validarDadosPessoa;
    // this.msgEnderecoAdicional = data.msgEnderecoAdicional;
  }

  ngAfterViewInit(): void {
    this.formChangesSubscription$ = this.vendaEnderecoForm.valueChanges.subscribe((values) => {
      if (this.vendaEnderecoForm.dirty) {
        setTimeout(() => {
          this.atualizar();
        }, 100);
      }
    });
  }

  ngOnInit(): void {
    this.ePedido = this.mostrarDadosPessoa;

    this.buscarInscricaoEstadualObg();
    this.buscarPremissasSistema();
    this.buscarFontesConsultaCnpj();

    if (!this.mostrarDadosPessoa) {
      if (this.enderecoEntrega !== undefined && this.enderecoEntrega.cep && !this.enderecoEntrega.rua) {
        this.buscarEnderecoPorCep();
      } else if (this.enderecoEntrega !== undefined && this.enderecoEntrega.uf) {
        this.buscarCidades();
      }
    } else {
      if (this.enderecoEntrega.uf === null || this.enderecoEntrega.uf === undefined) {
        this.enderecoEntrega.tipo = 0;
      }
    }

    this.buscarCidades();
  }

  buscarInscricaoEstadualObg() {
    this.carregandoService.mostra('buscarInscricaoEstadualObg');
    this.premissasService.consultarInscricaoEstadualObg().subscribe(
      (dados) => {
        this.inscricaoEstadualObg = dados.valor;
        this.carregandoService.esconde('buscarInscricaoEstadualObg');
      },
      (erro) => {
        this.carregandoService.esconde('buscarInscricaoEstadualObg');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.enderecoEntrega.cep).subscribe(
      (viaCep: ViaCep) => {
        this.enderecoEntrega.bairro = viaCep.bairro;
        // this.cliente.compl = viaCep.complemento;
        this.enderecoEntrega.rua = viaCep.logradouro;
        this.enderecoEntrega.uf = viaCep.uf;
        this.enderecoEntrega.ibge = Number(viaCep.ibge);

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde('buscaEnderecoPorCep');
      },
      (erro) => {
        this.carregandoService.esconde('buscaEnderecoPorCep');
        this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.enderecoEntrega.uf).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges.map((p) => {
          return { cidade: p.cidade, cod: Number(p.cod) };
        });

        if (nomeCidade) {
          this.enderecoEntrega.ibge = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
              this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
          )
            ? Number(
                this.cidades.find(
                  (s) =>
                    this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) ===
                    this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())
                ).cod
              )
            : undefined;
        } else {
          if (this.enderecoEntrega.ibge !== null && this.enderecoEntrega.ibge !== undefined) {
            this.enderecoEntrega.ibge = this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge)
              ? Number(this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge).cod)
              : undefined;
          } else {
            this.enderecoEntrega.ibge = undefined;
          }
        }

        this.carregandoService.esconde('buscaCidades');
      },
      (erro) => {
        this.carregandoService.esconde('buscaCidades');
      }
    );
  }

  focalizaNumero() {
    $('#numerove').focus();
  }

  consultarCnpj(idFonte: string | null = null) {
    this.carregandoService.mostra('consultarCnpj');

    this.consultaCnpjService.consultar(this.enderecoEntrega.cpfCnpj, idFonte).subscribe(
      (data) => {
        const resultado = data.result;

        let telefone: string | null = null;

        if (resultado.telefones && resultado.telefones.length > 0) {
          telefone = resultado.telefones[0];
        }

        let email: string | null = null;

        if (resultado.emails && resultado.emails.length > 0) {
          email = resultado.emails[0];
        }

        this.enderecoEntrega.cpfCnpj = resultado.cnpj;
        this.enderecoEntrega.nome = resultado.razaoSocial;

        this.enderecoEntrega.rua = resultado.logradouro;
        this.enderecoEntrega.numero = resultado.numero != null ? resultado.numero : this.enderecoEntrega.numero;
        this.enderecoEntrega.complemento =
          resultado.complemento != null ? resultado.complemento : this.enderecoEntrega.complemento;
        this.enderecoEntrega.bairro = resultado.bairro;
        this.enderecoEntrega.ibge = undefined;
        this.enderecoEntrega.uf = resultado.uf;
        this.enderecoEntrega.cep = resultado.cep;

        this.buscarCidades(resultado.cidade);

        this.enderecoEntrega.celular = telefone != null ? telefone : this.enderecoEntrega.celular;
        this.enderecoEntrega.email = email != null ? email : this.enderecoEntrega.email;
        this.buscouCNPJ = true;

        this.carregandoService.esconde('consultarCnpj');
      },
      (erro) => {
        this.carregandoService.esconde('consultarCnpj');
        this.notificacaoService.erro(erro);
      }
    );
  }

  voltar() {
    this.retornar.emit(false);
  }

  validar() {
    if (this.somenteLeitura) {
      return true;
    }

    if (
      this.validarDadosPessoa &&
      this.enderecoEntrega.tipo === 0 &&
      !this.buscouCNPJ &&
      this.vendaEnderecoForm.dirty
    ) {
      return false;
    }

    if (this.enderecoEntrega.ibge === undefined || this.enderecoEntrega.ibge === null) {
      return false;
    }

    return this.vendaEnderecoForm.valid;
  }

  atualizar(validar: boolean = true) {
    if (validar) {
      if (this.validarDadosPessoa && this.enderecoEntrega.tipo === 0 && !this.buscouCNPJ) {
        const habilitaConsultaRapida = this.fontesConsultaCnpj.length == 1;
        const textoMensagem = habilitaConsultaRapida
          ? 'É necessário atualizar os dados do CNPJ informado. Deseja consultar agora?'
          : 'É necessário atualizar os dados do CNPJ informado.';
        const textoBotao = habilitaConsultaRapida ? 'Consultar' : 'Ok';

        swal({
          title: 'Atenção!!',
          text: textoMensagem,
          type: 'warning',
          showCancelButton: habilitaConsultaRapida,
          confirmButtonClass: 'btn btn-info',
          confirmButtonText: textoBotao,
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            if (this.fontesConsultaCnpj.length === 1) {
              this.consultarCnpj(this.fontesConsultaCnpj[0].id);
            } else {
              // Existem múltiplas fontes de consulta, então ela tem que ser feita manualmente
            }
          }
        });

        return;
      }

      if (this.msgEnderecoAdicional != '') {
        swal({
          title: 'Atenção!!',
          text: this.msgEnderecoAdicional,
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-info',
          confirmButtonText: 'Ok',
          buttonsStyling: false
        }).then(() => {
          this.atualizar(false);
        });

        return;
      }
    }

    this.enderecoEntrega.cidade = this.enderecoEntrega.ibge
      ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge)
        ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge).cidade
        : ''
      : '';
    this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.Personalizado;

    if (this.validar()) {
      this.retornar.emit(this.enderecoEntrega);
    }
  }

  salvar(validar: boolean = true) {
    if (validar) {
      if (this.validarDadosPessoa && this.enderecoEntrega.tipo === 0 && !this.buscouCNPJ) {
        const habilitaConsultaRapida = this.fontesConsultaCnpj.length == 1;
        const textoMensagem = habilitaConsultaRapida
          ? 'É necessário atualizar os dados do CNPJ informado. Deseja consultar agora?'
          : 'É necessário atualizar os dados do CNPJ informado.';
        const textoBotao = habilitaConsultaRapida ? 'Consultar' : 'Ok';

        swal({
          title: 'Atenção!!',
          text: textoMensagem,
          type: 'warning',
          showCancelButton: habilitaConsultaRapida,
          confirmButtonClass: 'btn btn-info',
          confirmButtonText: textoBotao,
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            if (this.fontesConsultaCnpj.length === 1) {
              this.consultarCnpj(this.fontesConsultaCnpj[0].id);
            } else {
              // Existem múltiplas fontes de consulta, então ela tem que ser feita manualmente
            }
          }
        });

        return;
      }

      if (this.msgEnderecoAdicional != '') {
        swal({
          title: 'Atenção!!',
          text: this.msgEnderecoAdicional,
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-info',
          confirmButtonText: 'Ok',
          buttonsStyling: false
        }).then(() => {
          this.salvar(false);
        });

        return;
      }
    }

    this.enderecoEntrega.cidade = this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge)
      ? this.cidades.find((s) => s.cod === this.enderecoEntrega.ibge).cidade
      : '';
    this.enderecoEntrega.tipoEndereco = TipoEnderecoEntrega.Personalizado;

    this.retornar.emit(this.enderecoEntrega);
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.bloqueiaAlterecaoEndereco = premissas.bloquearAlteracaoNovoEnderecoEntregaCNPJ;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  validarBuscaCNPJ() {
    this.buscouCNPJ = false;
  }

  limparClienteFaturamento(tipo: number) {
    this.enderecoEntrega = new VendaEntrega();
    this.enderecoEntrega.tipo = tipo;
  }

  buscarFontesConsultaCnpj() {
    this.carregandoService.mostra('buscarFontesConsultaCnpj');

    this.consultaCnpjService.buscarFontes().subscribe(
      (data) => {
        this.fontesConsultaCnpj = data.results;
        this.carregandoService.esconde('buscarFontesConsultaCnpj');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFontesConsultaCnpj');
        this.notificacaoService.erro(erro);
      }
    );
  }

  limpar() {
    this.enderecoEntrega.rua = '';
    this.enderecoEntrega.numero = '';
    this.enderecoEntrega.complemento = '';
    this.enderecoEntrega.bairro = '';
    this.enderecoEntrega.uf = '';
    this.enderecoEntrega.cidade = '';
    this.enderecoEntrega.ibge = undefined;
  }

  ngOnDestroy(): void {
    if (this.formChangesSubscription$ !== null && this.formChangesSubscription$ !== undefined) {
      this.formChangesSubscription$.unsubscribe();
      this.formChangesSubscription$ = undefined;
    }
  }
}
